// extracted by mini-css-extract-plugin
export default {"main-container":"QuickbooksDisconnectCallback_main-container__vBwGJ"};